import React, { useContext, useEffect, useRef, useState } from "react";
import _ from "lodash";
import toast from "react-hot-toast";
import LanguageContext from "../../../utils/Contexts/LanguageContext";
import UserContext from "../../../utils/Contexts/UserContext";
import axiosInstance from "../../../utils/Requests/axios";
import TransactionsTable from "./TransactionTable";
import { useNavigate } from "react-router-dom";
import RightArrow from "../../svg/RightArrow";

function LatestTransaction() {
  const { userData } = useContext(UserContext);
  const { t } = useContext(LanguageContext);
  const navigate = useNavigate();
  const [tableData, setTableData] = useState(null);

  const transactionPayload = {
    columns: [{ data: "created" }],
    order: [{ column: 0, dir: "desc" }],
    length: 10,
  };

  const transactionsFetched = useRef(false);
  const fetchTransactions = () => {
    if (transactionsFetched.current) return;
    transactionsFetched.current = true;
    const payload = _.cloneDeep(transactionPayload);
    const url = `users/${userData?.uuid}/transactions/search`;
    axiosInstance
      .post(url, payload)
      .then((response) => {
        setTableData(response?.data?.data);
      })
      .catch(() => {
        toast.error(t("There was an error fetching Transactions data"));
      });
  };

  useEffect(() => {
    fetchTransactions();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="card cardSetting pb-3">
      <div className="card-header d-flex justify-content-between ps-3 pb-3 pt-4 ">
        <h4 className="card-title">{t("Latest Transaction")}</h4>
        <span className="card-text text-primary cursor-pointer d-flex align-items-center see-more"
         onClick={() => navigate("/transactions")}>
          {t("See More")} <RightArrow />
        </span>
      </div>
      <TransactionsTable data={tableData} />
    </div>
  );
}

export default LatestTransaction;
